module.exports = __webpack_public_path__ + "static/img/uniqueBg3.268b69bd.png";